import { DownOutlined, UserOutlined } from '@ant-design/icons';
import { Dropdown, Menu, message, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { currentUser, userLogout } from '../../../../features/user/userSlice';
import { userLogout_ } from '../../../../api/User/index';
import { useNavigate } from 'react-router-dom'
import {useQueryClient} from "react-query";

const MenuList = ({ userData }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector(currentUser);
  const navigate = useNavigate();
  const queryClient = useQueryClient()

  const logout = async () => {
    const { code } = await userLogout_();
    message.success(t('logoutSuccess'));
    dispatch(userLogout());
    queryClient.removeQueries()
    navigate('/');
  };

  return (
    <Menu
      className="user-menu"
      items={[
        // {
        //   key: '0',
        //   label: (
        //     <span>
        //       {t('TeamTable.integral') + ' : ' + userData?.user?.current_points}
        //     </span>
        //   ),
        // },
        {
          key: '1',
          label: (
            <Link to={'/user'}>
              {user && user.user.type === 1
                ? t('projects center')
                : t('user')}
            </Link>
          ),
        },
        {
          key: '2',
          danger: true,
          onClick: logout,
          label: t('logout'),
        },
      ]}
    />
  );
};

const User = ({ user, userData }) => (
    <>
        <Dropdown overlay={<MenuList userData={userData} />}>
            <Space size={'small'} className="user-menu-space">
                <UserOutlined style={{ color: '#fff' }} />
                <span>{user}</span>
                <DownOutlined style={{ color: '#fff' }} />
            </Space>
        </Dropdown>
    </>
);

export default User;
